<template>
  <div class="Box">
    <div v-if="title" class="title" :title="title">
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
}
</script>

<style lang="scss">
.Box {
  @include trans;
  background: $white;
  border: 1px solid $border-color-light;
  border-radius: $radius;
  box-shadow: $shadow-md;
  margin-bottom: 1rem;
  overflow: hidden;
  position: relative;

  > .title {
    // @include ellipsis;
    font-size: $h4;
    font-weight: $semibold;
    padding: 1rem 1rem 0;
  }

  .Empty {
    margin: 0;
  }

  &:hover {
    box-shadow: $shadow-lg;
  }
}
</style>
